import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
interface SuccessScreenProps {
  onViewList: () => void;
  onNewRequest: () => void;
}
export function SuccessScreen({
  onViewList,
  onNewRequest
}: SuccessScreenProps) {
  return <div className="min-h-screen bg-background flex items-center justify-center p-4" data-id="element-246">
      <div className="max-w-md w-full bg-card border border-border rounded-lg shadow-sm p-8 text-center" data-id="element-247">
        <div className="flex justify-center mb-6" data-id="element-248">
          <CheckCircle2Icon className="h-16 w-16 text-primary" data-id="element-249" />
        </div>
        <h1 className="text-2xl font-bold text-foreground mb-2" data-id="element-250">Thank You!</h1>
        <p className="text-muted-foreground mb-8" data-id="element-251">
          Your group setup request has been submitted. We&apos;ll review it and get back to you
          shortly. The request remains saved so you can open it again from the list.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center" data-id="element-252">
          <button type="button" onClick={onViewList} className="px-6 py-2 bg-violet-blue text-white rounded-md font-medium hover:bg-violet-blue/90" data-id="element-253">
            Back to Saved Requests
          </button>
          <button type="button" onClick={onNewRequest} className="px-6 py-2 bg-secondary text-secondary-foreground hover:bg-secondary/80 rounded-md font-medium" data-id="element-254">
            New Request
          </button>
        </div>
      </div>
    </div>;
}